import type { Module } from 'vuex'
import type { RootState } from '@/store'
import type { AdminPanelState, AdminPanelAccountRow } from './types'
import { ADMIN_PANEL_ACTIONS, ADMIN_PANEL_GETTERS, ServiceKey } from './types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const adminPanel: Module<AdminPanelState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export { ADMIN_PANEL_ACTIONS, ADMIN_PANEL_GETTERS, ServiceKey }
export type { AdminPanelState, AdminPanelAccountRow }
export default adminPanel
